import React from "react";
import CollapsibleGroups from "./CollapsibleGroups";
import arrowIcon from "../icons/icono-flecha.svg";
import "../stylesheets/layout/home/Search.scss";
import lupa from "../icons/icono-lupa.svg";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openGroups: false,
      dropLabel: "Filtros",
    };
    this.toggle = this.toggle.bind(this);
    this.toggleGroups = this.toggleGroups.bind(this);
    this.deleteButton = this.deleteButton.bind(this);
    this.deleteButtonGroups = this.deleteButtonGroups.bind(this);
    this.setDropLabel = this.setDropLabel.bind(this);
  }

  toggle() {
    this.toggleGroups();
    this.setState(() => {
      return {
        open: !this.state.open,
      };
    });
  }
  toggleGroups() {
    this.setState(() => {
      return {
        openGroups: !this.state.openGroups,
      };
    });
  }
  deleteButton = function () {
    const selectButton = document.getElementsByClassName("brands__btn");
    this.props.deleteSearch(selectButton);
  };
  deleteButtonGroups = function () {
    const groupsButton = document.getElementsByClassName("groups__btn");
    this.props.deleteSearchGroups(groupsButton);
  };

  setDropLabel = function (label) {
    this.setState(() => {
      return {
        dropLabel: label,
      };
    });
  };

  
  render() {
    const {
      handleTextFilter,
      search,
      groups,
      handleGroupFilter,
      selectGroups,
      dropdown,
      handleSearchDropdown,
      handleToggleDropdown,
      isToggleOpen,
    } = this.props;

    return (
      <div className="search">
        <div className="filter-search">
          <div className="name">
            <input
              onChange={handleTextFilter}
              className="name__input"
              type="text"
              id="name"
              value={search}
              placeholder="buscador"
            />
            <img className="name__input-lupa" src={lupa} alt="icono lupa" />
            
          </div>
        </div>
        <div className="menu-filtros">
          <div className="menu-label-filtros">
            <label
              htmlFor="groups"
              className="groups__label"
              onClick={handleToggleDropdown}
            >
              {this.state.dropLabel}
              <img
                className={`groups__back-arrow ${isToggleOpen ? 'open' : ''}`}
                src={arrowIcon}
                alt="icono flecha"
              />
            </label>
          </div>
          <div className={`wrapper${isToggleOpen ? " abierto" : ""}`} onClick={handleToggleDropdown}>
            <button onClick={() => { handleSearchDropdown("Todos"); this.setDropLabel("Todos");}} className={`filter ${dropdown === "Todos" ? "active" : ""}`} disabled={dropdown === "Todos"}>Todos</button>
            <button onClick={() => { handleSearchDropdown("BeerName"); this.setDropLabel("Nombre");}} className={`filter ${dropdown === "BeerName" ? "active" : ""}`} disabled={dropdown === "BeerName"}>Nombre</button>
            <button onClick={() => { handleSearchDropdown("Estilo"); this.setDropLabel("Estilo");}} className={`filter ${dropdown === "Estilo" ? "active" : ""}`} disabled={dropdown === "Estilo"}>Estilo</button>
            <button onClick={() => { handleSearchDropdown("EscuelaEstilo"); this.setDropLabel("Escuela");}} className={`filter ${dropdown === "EscuelaEstilo" ? "active" : ""}`} disabled={dropdown === "EscuelaEstilo"}>Escuela</button>
            <button onClick={() => { handleSearchDropdown("Amargo"); this.setDropLabel("Amargor");}} className={`filter ${dropdown === "Amargo" ? "active" : ""}`} disabled={dropdown === "Amargo"}>Amargor</button>
            <button onClick={() => { handleSearchDropdown("Levadura");this.setDropLabel("Levadura");}} className={`filter ${dropdown === "Levadura" ? "active" : ""}`} disabled={dropdown === "Levadura"}>Levadura</button>
            <button onClick={() => { handleSearchDropdown("Alcohol");this.setDropLabel("Alcohol");}} className={`filter ${dropdown === "Alcohol" ? "active" : ""}`} disabled={dropdown === "Alcohol"}>Alcohol</button>
            <button onClick={() => { handleSearchDropdown("NotaCata");this.setDropLabel("Nota de Cata");}} className={`filter ${dropdown === "NotaCata" ? "active" : ""}`} disabled={dropdown === "NotaCata"}>Nota de Cata</button>
          </div>
        </div>
        <div className="menu-brands">
          <div className="menu-label-brands">
            <label
              htmlFor="groups"
              className="groups__label"
              onClick={this.toggleGroups}
            >
              gama
              <img
                className={`groups__back-arrow ${this.state.openGroups ? 'open' : ''}`}
                src={arrowIcon}
                alt="icono flecha"
              />
            </label>
          </div>
          <div className={`brands${this.state.openGroups ? " abierto" : ""}`} onClick={this.toggle}>
            {selectGroups.length >= 1 ? (
              <div className="groups__selected-container">
                <p className="groups__selected-items">
                  ({selectGroups.length}{" "}
                  {selectGroups.length === 1 ? (
                    <span>Selecionada</span>
                  ) : (
                    <span>Seleccionadas</span>
                  )}{""}
                  )
                </p>
                <button
                  className="groups__selected-delete-btn"
                  onClick={this.deleteButtonGroups}
                >
                  borrar
                </button>
              </div>
            ) : null}
            {groups.map((group, index) => {
              return (
                <CollapsibleGroups open={this.state.openGroups} key={index} style="margin:0">
                  <button
                    value={group.ID}
                    onClick={handleGroupFilter}
                    id="selectButton2"
                    className="groups__btn"
                  >
                    {group.Name}
                  </button>
                </CollapsibleGroups>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Search;
